import React, { CSSProperties, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../api';

import { RootStore } from '../app/types';


const inputStyle: CSSProperties = {
    borderRadius: 5,
    fontSize: "1.2em",
    marginTop: "10px",
    marginBottom: "10px",
    padding: "15px",
};

const buttonStyle: CSSProperties = {
    padding: "5px 10px 5px 10px",
    borderRadius: 5,
    fontSize: "1.2em",
    backgroundColor: "light-blue",
    float: "right",
};

export const Login = ({onLoginOk}) => {
    const dispatch = useDispatch();
    const [loginErr, setLoginErr] = useState("");
    const [username,setUsername] = useState("");
    const [password,setPassword] = useState("");

    const isLoggedIn = useSelector((state: RootStore) => state.loggedInUser !== null);
    const loggedInUserName = useSelector((state: RootStore) => state.loggedInUser?.name ?? "");

    function onClickLogin() {
        setLoginErr("");
        login(dispatch, username, password)
            .then(() => {
                if (onLoginOk) onLoginOk();
            })
            .catch(err => {
                setLoginErr(err.message);
            });
    }

    function onClickLogout() {
        setLoginErr("");
        logout(dispatch).catch( err => {
            setLoginErr(err.message);
        });
    }

    return (
        <div >
            <div hidden={isLoggedIn}>
                <div>
                    <input style={inputStyle}
                        placeholder="email"
                        value={username}
                        onChange={e => setUsername(e.target.value)}/>
                </div>
                <div>
                    <input style={inputStyle}
                        placeholder="password"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        onKeyDown={(event)=> {if(event.key === "Enter") onClickLogin()}}/>
                </div>
                <div>
                    <div style={{color: "orange", marginLeft: 10}} hidden={!loginErr.length}>{loginErr}</div>
                    <button style={buttonStyle} onClick={onClickLogin}>
                        Submit
                    </button>
                </div>
            </div>
            {isLoggedIn && <div>
                <div style={{margin: 20}}>{loggedInUserName}</div>
                <button style={buttonStyle} onClick={onClickLogout}>
                    Logout
                </button>
            </div>}
        </div>
    );
}
